import { useEffect, useRef, useState } from 'react'
import AccountTable from './accountTable'
import { SBack, SGeneralForms } from 'shj-components'
import { useParams } from 'react-router-dom'
import { Card } from 'antd'
import { qualityMoneyAccountById } from '@/services/qualityMoneyAccount.ts'
import dayjs from 'dayjs'
import { moneyRender } from '@/utils'
import { authDict } from 'shj-utils'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'

const AccountDetail = (props: any) => {
  const formRefs = useRef<any>()
  const params = useParams()
  const id = params?.id || ''
  const companyCode = params?.companyCode || ''
  const idCard = params?.accountCode || ''
  const [pageData, setPageData] = useState<any>({})

  useEffect(() => {
    getDetail()
  }, [])

  const getDetail = () => {
    qualityMoneyAccountById(id, {
      params: {
        labelFlag: false,
      },
    }).then(res => {
      if (res) {
        setPageData(res)
      }
    })
  }
  const setPhone = (name, labelFlag) => {
    qualityMoneyAccountById(id, {
      params: {
        labelFlag,
      },
    }).then(res => {
      if (res) {
        formRefs?.current?.onFormRef()?.setFieldValue(name, res[name])
        pageData[name] = res[name]
        setPageData({ ...pageData })
      }
    })
  }
  return (
    <>
      <SBack title={'质保金详情'} level={2}>
        <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <SGeneralForms
            ref={formRefs}
            detailsData={pageData}
            isDetail={true}
            configs={[
              {
                title: '账户信息',
                titleMode: 'drawer',
                formItem: [
                  {
                    name: 'companyName',
                    label: '门店',
                  },
                  {
                    name: 'extEmpName',
                    label: '名字',
                  },
                  {
                    name: 'postName',
                    label: '技能标签',
                  },
                  {
                    name: 'phone',
                    label: '电话',
                    children: () => (
                      <div style={{ color: 'rgb(153,153,153)' }}>
                        <span>{pageData?.phone}</span>
                        {authDict['returnMoneyPhone'] ? (
                          pageData && pageData?.phone && pageData?.phone.includes('*') ? (
                            <EyeInvisibleOutlined
                              onClick={() => setPhone('phone', true)}
                              style={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <EyeOutlined
                              onClick={() => setPhone('phone', false)}
                              style={{ cursor: 'pointer' }}
                            />
                          )
                        ) : null}
                      </div>
                    ),
                  },
                  {
                    name: 'idCard',
                    label: '身份证号',
                    children: () => (
                      <div style={{ color: 'rgb(153,153,153)' }}>
                        <span>{pageData?.idCard}</span>
                        {authDict['returnMoneyIdCard'] ? (
                          pageData && pageData?.idCard && pageData?.idCard.includes('*') ? (
                            <EyeInvisibleOutlined
                              onClick={() => setPhone('idCard', true)}
                              style={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <EyeOutlined
                              onClick={() => setPhone('idCard', false)}
                              style={{ cursor: 'pointer' }}
                            />
                          )
                        ) : null}
                      </div>
                    ),
                  },
                  {
                    name: 'joinDate',
                    label: '入职日期',
                    children: () => {
                      return (
                        <div style={{ color: 'rgb(153,153,153)' }}>
                          {pageData['joinDate']
                            ? dayjs(pageData['joinDate']).format('YYYY-MM-DD')
                            : '-'}
                        </div>
                      )
                    },
                  },
                  {
                    name: 'actStatusName',
                    label: '人员状态',
                  },
                  {
                    name: 'accountBalance',
                    label: '质保金余额(¥)',
                    children: () => {
                      return (
                        <div style={{ color: 'rgb(153,153,153)' }}>
                          {moneyRender(pageData['accountBalance'])}
                        </div>
                      )
                    },
                  },
                  {
                    name: 'payFrozenAmount',
                    label: '支出冻结金额(¥)',
                    children: () => {
                      return (
                        <div style={{ color: 'rgb(153,153,153)' }}>
                          {moneyRender(pageData['payFrozenAmount'])}
                        </div>
                      )
                    },
                  },
                  {
                    name: 'availableAmount',
                    label: '可用金额(¥)',
                    children: () => {
                      return (
                        <div style={{ color: 'rgb(153,153,153)' }}>
                          {moneyRender(pageData['availableAmount'])}
                        </div>
                      )
                    },
                  },
                  {
                    name: 'isRefund',
                    label: '是否实退',
                    children: () => {
                      return (
                        <div style={{ color: 'rgb(153,153,153)' }}>
                          {pageData['isRefund'] ? '是' : '否'}
                        </div>
                      )
                    },
                  },
                  {
                    name: 'fmsCompanyName',
                    label: '财务主体',
                  },
                  {
                    name: 'vendorName',
                    label: '承包商',
                  },
                ],
              },
            ]}
          />
        </Card>
        <Card style={{ marginTop: '10px' }}>
          <AccountTable
            accountId={id}
            companyCode={companyCode}
            user={pageData}
            accountCode={idCard}
          />
        </Card>
      </SBack>
    </>
  )
}

export default AccountDetail
